<template>
  <div
    class="upload-content"
    :class="{
      'in-dialog': isInDialog
    }"
  >
    <h2 class="upload-title" v-if="!hideActions">
        请上传你的简历
      </h2>
    <div class="upload-content-wrapper">
      
      <div class="upload-subtitle">
        <div class="upload-subtitle-text">上传求职简历</div> 
        <img
        class="upload-subtitle-icon"
        src="../assets/img/profile.svg"
        alt="upload-decor"
      /> 
      </div>
      
      <!-- 使用 Element UI 上传组件，主要样式交给组件自身 -->
      <el-upload
        ref="resumeUpload"
        class="resume-upload"
        drag
        action="/api/upload/resume"
        :http-request="handleCustomUpload"
        :show-file-list="false"
        :on-progress="handleUploadProgress"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="handleBeforeUpload"
        accept=".doc,.docx,.pdf,.png,.jpg,.jpeg"
      >
        <!-- 初始状态：未开始上传 -->
        <div v-if="!uploading && !uploadDone">
          <img
            class="upload-icon"
            :src="uploadLoadingImage"
            alt="upload-loading"
          />
          <div class="el-upload__text">
            <span>点击或拖拽文件到此处上传</span>
          </div>
          <div class="el-upload__tip">
            支持 DOC / DOCX / PNG / JPG / PDF，大小不超过 10MB
          </div>
        </div>
        <!-- 上传中 -->
        <div v-else-if="uploading" class="upload-loading">
          <img
            class="upload-icon"
            :src="loadingImage"
            alt="upload-loading"
          />
          <div class="upload-file uploading-loading">
            <div class="upload-file-info">
              <span class="file-name file-color">{{ uploadedFileName }}</span>
              <span class="file-color">{{ uploadedFileSize }}</span>
            </div>
            <el-progress
              class="upload-progress"
              :percentage="uploadPercent"
              :stroke-width="4"
              status="success"
              color="#62AFFF"
              :show-text="false"
            />
            <div class="upload-result-row">
              <span class="file-color">上传中</span>
              <span class="file-color">{{ uploadPercent }}%</span>
            </div>
          </div>
        </div>
        <!-- 上传完成 -->
        <div class="upload-success" v-else>
          <img
            class="upload-icon"
            :src="uploadSuccessImage"
            alt="upload-loading"
          />
          <div class="upload-file">
            <div class="upload-file-info">
              <span class="file-name file-color">{{ uploadedFileName }}</span>
              <span class="file-color">{{ uploadedFileSize }}</span>
            </div>
            <el-progress
              class="upload-progress"
              :percentage="100"
              :stroke-width="4"
              status="success"
              color="#62AFFF"
              :show-text="false"
            />
            <div class="upload-result-row">
              <span class="file-color">上传成功</span>
              <span class="file-color">100%</span>
            </div>
          </div>
          <span class="file-color">文件上传成功，可以继续下一步</span>
          
        </div>
      </el-upload>

      <div class="resume-upload-actions">
        <el-button
          class="btn-reupload"
          type="text"
          size="small"
          @click="handleReupload"
        >
          <div class="btn-reupload-content">
            <img
              class="btn-reupload-icon"
              src="../assets/img/refresh.png"
              alt="refresh"
            />
            <span>重新上传</span>
          </div>
          
        </el-button>
        <el-button class="upload-library-btn" size="small" @click="openResumeLibraryModal">
          简历库上传简历
        </el-button>
      </div>

    </div>
    <div v-if="!hideActions" class="action-buttons">
      <button class="btn-back" @click="$emit('back')">上一步</button>
      <button
        class="btn-next"
        :disabled="!uploadDone"
        @click="$emit('next')"
      >
        下一步
      </button>
    </div>

    <!-- 简历库选择弹窗 -->
    <ResumeLibraryModal 
      :visible="showResumeLibraryModal"
      @select="handleResumeSelect"
      @close="closeResumeLibraryModal"
    />
  </div>
</template>

<script>
import { uploadResume } from '@/api/upload'
import ResumeLibraryModal from './ResumeLibraryModal.vue'

export default {
  name: 'UploadContent',
  components: {
    ResumeLibraryModal
  },
  props: {
    selectedMbti: {
      type: String,
      default: ''
    },
    // 是否在弹框中展示，用于控制内边距
    isInDialog: {
      type: Boolean,
      default: false
    },
    hideActions: {
      type: Boolean,
      default: false
    }
  },
  emits: ['back', 'next', 'uploaded'],
  data() {
    return {
      uploading: false,
      uploadPercent: 0,
      uploadDone: false,
      // 自定义上传中图标
      uploadLoadingImage: require('../assets/img/upload.png'),
      uploadSuccessImage: require('../assets/img/exportSuccess.png'),
      loadingImage: require('../assets/img/loading.png'),

      uploadedFileName: '',
      uploadedFileSize: '',
      // 简历库相关
      showResumeLibraryModal: false
    }
  },
  methods: {
    /**
     * 自定义上传方法，使用公共的上传方法
     */
    handleCustomUpload(options) {
      return uploadResume({
        ...options,
        url: '/api/upload/resume',
        encodeFileName: true // 对文件名进行编码
      })
    },
    handleReupload() {
      const uploader = this.$refs.resumeUpload
      if (uploader) {
        // 清空已选文件和进度状态
        uploader.clearFiles()
        this.uploading = false
        this.uploadPercent = 0
        this.uploadDone = false
        // 主动触发文件选择
        const input = uploader.$el.querySelector('input[type="file"]')
        if (input) {
          input.click()
        }
      }
    },
    handleBeforeUpload(file) {
      this.uploading = true
      this.uploadPercent = 0
      this.uploadDone = false
      // 记录文件名和大小，优先使用原始文件对象（支持中文名）
      const raw = file && (file.raw || file)
      if (raw) {
        const name = raw.name || ''
        // 防止后端返回的 URL/编码串，直接用本地文件名，并做一次 decode 兼容
        this.uploadedFileName = decodeURIComponent(name)
        const sizeMB = raw.size ? (raw.size / 1024 / 1024) : 0
        this.uploadedFileSize = sizeMB ? `${sizeMB.toFixed(2)} MB` : ''
      } else {
        this.uploadedFileName = ''
        this.uploadedFileSize = ''
      }
    },
    handleUploadProgress(event) {
      // Element UI 会带上百分比（0-100）
      this.uploadPercent = Math.round(event.percent || 0)
    },
    handleUploadSuccess(response) {
      this.uploadPercent = 100
      this.uploading = false
      this.uploadDone = true
      console.log(response,response?.data?.data?.resumeUrl, 'response')
      let url = response?.data?.data?.resumeUrl
      this.$emit('uploaded', url)
    },
    handleUploadError() {
      this.uploading = false
      this.uploadPercent = 0
      this.uploadDone = false
      this.$message.error('简历上传失败，请稍后重试')
    },
    // 简历库相关方法
    openResumeLibraryModal() {
      this.showResumeLibraryModal = true
    },
    closeResumeLibraryModal() {
      this.showResumeLibraryModal = false
    },
    handleResumeSelect(resume) {
      try {
        // 直接使用简历库中的 URL，不需要下载和重新上传
        const resumeUrl = resume.resume_url || resume.url
        if (!resumeUrl) {
          throw new Error('简历URL不存在')
        }

        // 更新状态
        this.uploadedFileName = resume.resume_name || resume.name || 'resume.pdf'
        this.uploadedFileSize = resume.resume_size || 0
        this.uploading = false
        this.uploadPercent = 100
        this.uploadDone = true
        
        // 直接触发 uploaded 事件，传递简历库中的 URL
        this.$emit('uploaded', resumeUrl)
        this.$message.success('简历选择成功')
        this.closeResumeLibraryModal()
      } catch (error) {
        console.error('从简历库选择简历失败:', error)
        this.uploading = false
        this.uploadPercent = 0
        this.uploadDone = false
        this.$message.error(error?.message || '选择简历失败，请稍后重试')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-base {
  padding: 0 24px;
  height: 36px;
  line-height: 36px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.upload-content{
  padding: 0 150px;
  ::v-deep .el-upload-dragger:hover{
   border: 2px solid #62AFFF33
  }
  ::v-deep .el-upload{
    width: 100%
  }
  ::v-deep .el-upload-dragger{
    width: 100%;
    padding-top: 12px;
  }
}

// 弹框模式下的紧凑样式（左右 padding 收窄，整体更贴合弹框）
.upload-content.in-dialog {
  padding: 0 24px;

  .upload-content-wrapper {
    padding: 16px 20px;
  }
}
.upload-content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 1px 1px 10px 0px #0000000D;
  border-radius: 8px;
  padding: 24px;
  
}

.upload-title {
  font-size: 26px;
  font-weight: 500;
  color: #656587;
  margin: 0 0 24px 0;
  text-align: center;
}
.upload-subtitle{
    display: flex;;
    justify-content: space-between;
    align-items: center;
    width: 100%; 
    margin-bottom: 24px;
    .upload-subtitle-text{
      font-size: 20px;
      color: #656587;
      font-weight: 700;
    }
  }



.resume-upload {
  width: 100%;
  margin-bottom: 16px;
}
.upload-icon {
  height: 56px;
}
.upload-loading-icon {
  width: 40px;
  height: 40px;
}

.upload-progress {
  margin: 8px 0px;
}


.upload-success{
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  padding: 0 20px;
  margin-top: -10px;
}
.upload-loading{
  margin-top: -10px;
}

.upload-file{
  background: linear-gradient(320.78deg, rgba(255, 255, 255, 0.4) 2.06%, rgba(255, 255, 255, 0.723077) 42.17%, rgba(255, 255, 255, 0.8) 99.08%);
  box-shadow: 4px 4px 20px 0px #0000000D;
  box-shadow: 1px 1px 10px 0px #0000000D;
  backdrop-filter: blur(30px);
  margin: -16px 20px 0 20px;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
}
.uploading-loading{
  width: 96%;
}

.upload-file-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
}

.upload-file-info .file-name {
  font-weight: 500;
}

.file-color {
  color: #656587;
  font-size: 12px;
}

.upload-result-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}


.resume-upload-actions {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.btn-reupload {
  padding: 0;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  color: #606266;
}
.btn-reupload-content{
  display: flex;
  align-items: center;
}
.upload-library-btn{
  background: #62AFFF;
  color: #fff;
  border-radius: 4px;
}

.btn-reupload:hover {
  color: #409EFF;
}

.btn-reupload-icon {
  margin-right: 4px;
  width: 16px;
  height: 16px;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding-top: 20px;
}

.btn-back {
  @extend .btn-base;
  border: 1px solid #e0e0e0;
  color: #666;
  flex: 1;

  &:hover {
    background: #e9ecef;
    border-color: #d0d0d0;
  }
}

.btn-next {
  @extend .btn-base;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  border: none;
  color: #ffffff;
  font-weight: 500;
  flex: 1;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(177, 110, 249, 0.3);
  }
}


// 收缩状态下增加左右padding
.main-content.sidebar-collapsed .upload-content-wrapper,
.main-content.sidebar-collapsed .action-buttons {
  padding: 0 260px;
}

</style>

